import DeleteIcon from "../../Common/svg/deleteicon";
import EditIcon from "../../Common/svg/editIcon";
import EditPen from "../../Common/svg/editpenicon";
import Adressicon from "./adressicon";

const AddressCard = ({ address }) => {
  const {
    name,
    phone,
    is_default,
    street,
    house_number,
    apartment_number,
    zone,
    city,
    governorate,
    country,
    address_line_1,
  } = address;

  const addressTitle = name || "عنوان";
  const fullAddress = [
    street && `شارع ${street}`,
    house_number && `رقم المنزل ${house_number}`,
    apartment_number && `رقم الشقة ${apartment_number}`,
    zone?.name,
    city?.name,
    governorate?.name,
    country?.name,
    address_line_1,
  ].filter(Boolean).join(" - ");

  return (
    <div className="address-card">
      
      <div className="address-content" dir="rtl"> 
        <div className="address-header">
          <span className="address-title">{addressTitle}</span>
          {is_default && <span className="badge">افتراضي</span>}
          <span className="location-icon"><Adressicon/></span>
        </div>

        <p className="address-text">{fullAddress}</p>

        {phone && <p className="phone">{phone}</p>}
      </div>
      <div className="address-actions">
    
        <button className="icon-btn delete"><DeleteIcon/></button>
      </div>

    </div>
  );
};

export default AddressCard;
